<i (click)="openModal(deleteAppraisee)" class="mdi mdi-close"></i>
<ng-template #deleteAppraisee>
    <div class="delete-appraisee">
        <div class="modal-body">
            <div class="d-flex justify-content-center flex-column" style="min-height: 85px;">
                <div>
                    Are you sure you want to delete
                    of the appraisee?
                </div>
                <div class="m-t-10 m-b-10">
                    <span>
                        <input id="not-ask-again" [checked]="isDeleteModalHidden" (change)="changeModalBehaviour()" type="checkbox">
                        <label for="not-ask-again">Do not ask again.</label>
                    </span>
                </div>
            </div>
            <div class="btn-modal">
                <span (click)="onOkClicked()">OK</span>
                <span (click)="hideModal(deleteAppraisee)">Cancel</span>
            </div>
        </div>
    </div>
</ng-template>